import { render } from "./BankAccountsView.vue?vue&type=template&id=5c5d6254"
import script from "./BankAccountsView.vue?vue&type=script&lang=js"
export * from "./BankAccountsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__